<template>
    <Loading v-if="loadingPages"/>
    <template v-else>
        <div v-if="pagesList.length">
            <div v-if="pagesList.length >= 5" class="mb-base-2">
                <BaseInputText v-model="searchQuery" left_icon="search" :placeholder="$t('Search your pages')" />
            </div>
            <div v-for="page in filteredPages" :key="page.id" class="flex items-center gap-base-2 mb-base-2 cursor-pointer" @click="handleClickSwitchPage(page)">
                <PageSwitchItem :page="page"/>
                <div class="flex-1 font-bold">{{ page.name }}</div>
            </div>
            <router-link v-if="showSeeMore" :to="{ name: 'list_page' }">{{ $t('See more') }}</router-link>
        </div>
        <div v-else>{{ $t('Sorry, there is no page yet! Please create new page.') }}</div>
    </template>
    <BaseButton @click="createPage" class="mt-base-2" fluid>{{ $t('Create new page') }}</BaseButton>
</template>

<script>
import { mapState, mapActions } from 'pinia'
import { switchPage, searchMyUserPages } from '@/api/page'
import Loading from '@/components/utilities/Loading.vue'
import BaseButton from '@/components/inputs/BaseButton.vue'
import BaseInputText from '@/components/inputs/BaseInputText.vue'
import PageSwitchItem from '@/components/user_page/PageSwitchItem.vue'
import { usePagesStore } from '@/store/page'
import { useAuthStore } from '@/store/auth'
import { useUtilitiesStore } from '@/store/utilities'

export default {
    components: { Loading, BaseButton, PageSwitchItem, BaseInputText },
    data() {
		return {
			currentPage: 1,
            hasNextPage: false,
            searchQuery: '',
            searching: false,
            serverResults: []
		}
	},
    inject: ['dialogRef'],
    computed: {
        ...mapState(useAuthStore, ['user']),
		...mapState(usePagesStore, ['loadingPages', 'pagesList']),
        filteredPages(){
            const q = this.searchQuery?.trim()
            if (!q || q.length < 3) return this.pagesList
            return this.serverResults.length ? this.serverResults : this.pagesList
        },
        showSeeMore(){
            const q = this.searchQuery?.trim()
            return this.hasNextPage && (!q || q.length < 3)
        }
    },
    watch: {
        async searchQuery(q){
            const keyword = q?.trim()
            if (!keyword || keyword.length < 3){
                this.serverResults = []
                return
            }
            this.searching = true
            try{
                const res = await searchMyUserPages(keyword, 1)
                this.serverResults = res.items || []
            }catch(error){
                this.showError(error.error)
            }finally{
                this.searching = false
            }
        }
    },
    mounted(){
        this.getMyPagesList(this.currentPage).then((response) => {
            this.hasNextPage = response.has_next_page
        })	
    },
    unmounted(){
        this.unsetPagesList()
    },
    methods: {
        ...mapActions(useUtilitiesStore, ['setSelectedPage']),
        ...mapActions(usePagesStore, ['getMyPagesList', 'unsetPagesList']),
        handleClickSwitchPage(page){
            this.setSelectedPage(page)
            setTimeout(async() => {
                try {  
                    await switchPage(page.id)
                    window.location.href = page.href
                } catch (error) {
                    this.showError(error.error)
                    this.setSelectedPage(null)
                    this.dialogRef.close()
                }
            }, 1500);
		},
        createPage() {
            if (this.user) {
				let permission = 'user_page.allow_create'
                if(this.checkPermission(permission)){
                    this.$router.push({ 'name': 'user_pages_create' })
                }
			}
        }
    }
}
</script>
